import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@flowww/wizard/loader/index.es2017';
import { akitaConfig } from '@datorama/akita';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements as wizardCustomElements } from '@flowww/design-system/loader/index.es2017';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

defineCustomElements();
wizardCustomElements();

if (environment.production) {
  enableProdMode();
}

akitaConfig({ resettable: true });
// Configurar PDF.js worker
(window as any).pdfWorkerSrc = '/assets/pdfjs/pdf.worker.min.js';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
